module.exports = __webpack_public_path__ + "static/media/icon-piece6-8.e9a626a7.png";